export const INSPECT_VALUE_VIEW_TYPE = {
  BATTERY: 1,
  TIRE: 2,
  SIDE_SLIP: 3,
  BRAKE: 4,
  SPEED: 5,
  BRAKE_REAR: 6,
  SUNFLARE: 7,
  BOOTS: 8,
};

export const INSPECT_VALUE_LENGTH = [0, 1, 4, 1, 2, 1, 2, 2, 1];
